module.exports = __webpack_public_path__ + "media/images/emblems/Muzzano-coat_of_arms-7aa3806ddd07e4c8884bffb2df95ade5.svg";